import styled from 'styled-components';
import { motion } from 'motion/react';
import breakpoint, { getZindexByType } from '~/utils/style-utils.ts';
import { sidebarTop } from '~/utils/layout-utils.js';
import useUIContext from '~/ui/use-ui-context';
import { forwardRef } from 'react';

const SidebarWrapperStyled = styled(motion.div)`
	background-color: var(--sidebar-bg, rgba(var(--base-11), 1));
	${breakpoint.lg`
		box-shadow: -2px 8px 10px var(--sidebar-shadow, none);
	`};
	height: ${({ uiContext }) => (uiContext.hasStaticHeader ? `calc(100% - var(--regulationHeight))` : '100%')};
	overflow-x: hidden;
	position: fixed;
	right: 0;
	top: ${({ uiContext }) => (uiContext.hasStaticHeader ? `var(--regulationHeight)` : '0')};
	width: 100%;
	z-index: ${getZindexByType('sidebar')};
	-webkit-overflow-scrolling: touch;
	transform: none;
	${breakpoint.lg`
		position: fixed;
		height: ${({ uiContext }) => `calc(100% - ${sidebarTop(uiContext)})`};
		right: 0;
		top: ${({ uiContext }) => sidebarTop(uiContext)};
		width: var(--detailWidth);
	`};
	.menu,
	.deposit {
		height: auto;
		min-height: 100%;
	}
	.deposit {
		transform: none;
	}
	.menu.account-menu {
		transform: none;
		height: auto;
	}
	.menu .menu__content-wrapper {
		padding: 15px 0 12px 0;
		height: auto;
	}
	.u-box-bg {
		background-color: var(--sidebar-box, rgba(var(--base-11), 1));
	}
`;

const SidebarWrapper = forwardRef((props, ref) => {
	const uiContext = useUIContext();
	return (
		<SidebarWrapperStyled
			{...props}
			uiContext={uiContext}
			ref={ref}
			data-sidebar-wrapper="sidebar-wrapper-styled"
		/>
	);
});

export default SidebarWrapper;
